import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import NexusCommandCenterHomepage from "pages/nexus-command-center-homepage";
import ProjectDimensionsPortfolio from "pages/project-dimensions-portfolio";
import ArsenalShowcaseSkillsTechnologies from "pages/arsenal-showcase-skills-technologies";
import IdentityMatrixAbout from "pages/identity-matrix-about";
import NeuralNetworkContactCollaboration from "pages/neural-network-contact-collaboration";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<NexusCommandCenterHomepage />} />
        <Route path="/nexus-command-center-homepage" element={<NexusCommandCenterHomepage />} />
        <Route path="/project-dimensions-portfolio" element={<ProjectDimensionsPortfolio />} />
        <Route path="/arsenal-showcase-skills-technologies" element={<ArsenalShowcaseSkillsTechnologies />} />
        <Route path="/identity-matrix-about" element={<IdentityMatrixAbout />} />
        {/* Redirect legacy Mentorship route to Contact */}
        <Route path="/mentorship-nexus-services-learning" element={<Navigate to="/neural-network-contact-collaboration" replace />} />
        <Route path="/neural-network-contact-collaboration" element={<NeuralNetworkContactCollaboration />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;